module.exports = " <div class=Progress _v-5c15644d=\"\"> <tb-progress-blocks _v-5c15644d=\"\">Lessons</tb-progress-blocks> <tb-progress-bar :current=currentSection :max=maxSection _v-5c15644d=\"\">Sections</tb-progress-bar> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-5c15644d!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Progress.vue
// module id = 130
// module chunks = 2